import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["properties", "selectedProperties", "onChange"];
import I18n from 'I18n';
import { Body, Button, LayoutHorizontal, LayoutSpaceVertical, MultiSelect } from 'breeze-intelligence-kit';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SmartFillPropertySelect = _ref => {
  let {
      properties,
      selectedProperties,
      onChange
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const propertyNames = properties.map(property => ({
    text: property.label,
    value: property.propertyName,
    help: property.promptQuestion
  }));
  const isAllSelected = selectedProperties.length === properties.length;
  const selectedCount = selectedProperties.length;
  const handleChange = selectedPropertyNames => {
    onChange(selectedPropertyNames);
  };
  const handleSelectAll = () => {
    onChange(propertyNames.map(property => property.value));
  };
  const handleSelectNone = () => {
    onChange([]);
  };
  return /*#__PURE__*/_jsx(MultiSelect.Wrapper, {
    label: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      as: "span",
      gap: "space-xs",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartProperties.panel.multiSelect.label"
      }), /*#__PURE__*/_jsx(Body, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartProperties.panel.multiSelect.selectedCount",
          options: {
            count: selectedCount
          }
        })
      })]
    }),
    children: /*#__PURE__*/_jsx(MultiSelect, Object.assign({}, rest, {
      anchorType: "button",
      "aria-label": I18n.text('smartProperties.panel.multiSelect.label'),
      dropdownFooter: /*#__PURE__*/_jsxs(LayoutHorizontal, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: isAllSelected,
          onClick: handleSelectAll,
          variant: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartProperties.panel.multiSelect.selectAll"
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: !isAllSelected,
          onClick: handleSelectNone,
          variant: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartProperties.panel.multiSelect.clearAll"
          })
        })]
      }),
      onChange: handleChange,
      options: propertyNames,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartProperties.panel.multiSelect.placeholder"
      }),
      value: selectedProperties
    }))
  });
};